import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Multibrand-UI Components
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Input from '@zg-rentals/multibrand-ui/lib/Input';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import HR from '@zg-rentals/multibrand-ui/lib/HR';

import emailUtils from 'app/shared/utils/emailUtils';

// Actions
import UserManagementActions from 'app/shared/actions/UserManagementActions';

const SUPPORT_EMAIL_MSG = 'Please contact rentalpartners@zillowgroup.com to have this person added to your company.';

import './style.scss';

const propTypes = {
    currentUser: PropTypes.object.isRequired,
};

const AddUserStepOne = ({
    currentUser,
    onNextStep,
    onCancel,
    dispatch,
}) => {
    const [isVerifyingEmail, setIsVerifyingEmail] = React.useState(false);
    const [errors, setErrors] = React.useState({});

    const handleValidateEmail = () => {
        if (!emailUtils.isValid(currentUser.email)) {
            setErrors({
                ...errors,
                email: 'Please, enter a valid email address',
            });
            return;
        }
        setIsVerifyingEmail(true);
        setErrors({
            ...errors,
            email: 'Verifying...',
        });
        dispatch(UserManagementActions.verifyEmail(currentUser.email))
            .then(() => {
                setIsVerifyingEmail(false);
                setErrors({
                    ...errors,
                    email: null,
                });
            }).catch((err) => {
                setIsVerifyingEmail(false);
                const message = err.message.toLowerCase().includes('email')
                    ? err.message
                    : `${err.message} ${SUPPORT_EMAIL_MSG}`;
                setErrors({
                    ...errors,
                    email: message,
                });
            });
    };

    return (
        <div>
            <Row>
                <Col>
                    <Text type="h4">Enter basic information</Text>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Input
                        type="text"
                        placeholder="Email"
                        label="Email"
                        value={currentUser.email}
                        onChange={e => dispatch(UserManagementActions.currentUserSetEmail(e.target.value.trim()))}
                        onBlur={handleValidateEmail}
                        error={errors.email}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Input
                        type="text"
                        placeholder="Name"
                        label="Name"
                        value={currentUser.userName}
                        onChange={e => dispatch(UserManagementActions.currentUserSetName(e.target.value))}
                        error={errors.userName}
                    />
                </Col>
            </Row>
            <HR />
            <div className="Questions-footer">
                <Link className="Questions-button" onClick={onCancel}>
                    Cancel
                </Link>
                <Button
                    type="primary"
                    onClick={onNextStep}
                    disabled={Boolean(isVerifyingEmail
                        || errors.email || !currentUser.email || !currentUser.userName)}
                >
                    Continue
                </Button>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.userManagement.currentUser,
});

AddUserStepOne.propTypes = propTypes;

export default connect(mapStateToProps)(AddUserStepOne);
